import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, FormInstance, Input, Row, Space, Typography } from "antd";
import { FC } from "react";
import { NumericFormat } from "react-number-format";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";

type ValoresBonificacaoForm = {
  valorBonificacao: number | null;
};

type EditarBonificacaoModalProps = {
  form: FormInstance<ValoresBonificacaoForm>;
  valorBonificacaoAtual: number | null;
  onCancel: () => void;
  onSubmit: () => void;
  salvando: boolean;
};

type CurrencyInputProps = {
  value?: number | null;
  onChange?: (value: number | null) => void;
};

const { Text } = Typography;

const CurrencyInput: FC<CurrencyInputProps> = ({ value, onChange }) => (
  <NumericFormat
    value={value ?? ""}
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={4}
    fixedDecimalScale
    prefix="R$ "
    allowNegative={false}
    customInput={Input}
    onValueChange={({ floatValue }) => onChange?.(floatValue ?? null)}
  />
);

const EditarBonificacaoModal: FC<EditarBonificacaoModalProps> = ({ form, valorBonificacaoAtual, onCancel, onSubmit, salvando }) => (
  <Form form={form} layout="vertical" onFinish={onSubmit} preserve={false}>
    <Row gutter={12}>
      <Col span={24}>
        <Form.Item label="Valor atual">
          <Input value={currencyBRL(valorBonificacaoAtual ?? 0)} disabled />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item label="Novo valor de bonificação" name="valorBonificacao" rules={[{ required: true, message: "Informe o valor de bonificação" }]}>
          <CurrencyInput />
        </Form.Item>
      </Col>
    </Row>
    <Text type="secondary">Altere o valor e confirme para atualizar o resultado do sorteio.</Text>
    <Divider />
    <Row gutter={12}>
      <Col span={24} className="modalFooter">
        <Space size="middle">
          <Button className="cancelButton" onClick={onCancel} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary" loading={salvando}>
            SALVAR
          </Button>
        </Space>
      </Col>
    </Row>
  </Form>
);

export type { ValoresBonificacaoForm };
export default EditarBonificacaoModal;
